var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoNum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#679CF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7401 21.2398C21.2534 21.2398 22.4567 20.6964 23.3501 19.6098C24.2434 18.5231 24.6901 17.0798 24.6901 15.2798C24.6901 13.4664 24.2634 12.0098 23.4101 10.9098C22.5567 9.80977 21.3534 9.25977 19.8001 9.25977C18.2467 9.25977 17.0334 9.81643 16.1601 10.9298C15.2867 12.0431 14.8501 13.4131 14.8501 15.0398C14.8501 17.0131 15.2867 18.5398 16.1601 19.6198C17.0334 20.6998 18.2267 21.2398 19.7401 21.2398ZM13.4501 20.9998V20.5998H12.0501V9.35977H11.3301L7.31006 11.2198L7.43006 11.5998L9.05006 10.9798V20.5998H7.45006V20.9998H13.4501ZM18.2501 19.3798C18.5301 20.3531 19.0434 20.8398 19.7901 20.8398C20.5367 20.8398 21.0434 20.3598 21.3101 19.3998C21.5767 18.4398 21.7101 16.9864 21.7101 15.0398C21.7101 11.4531 21.0634 9.65977 19.7701 9.65977C18.4767 9.65977 17.8301 11.4531 17.8301 15.0398C17.8301 16.9598 17.9701 18.4064 18.2501 19.3798Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNum);
export default __webpack_public_path__ + "static/media/ico-num.be91945d190ba7b64d5956acdf8d0482.svg";
export { ForwardRef as ReactComponent };